import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { Row, Col, Spinner } from "reactstrap";
import Avatar from "components/Avatar/Avatar";
import dayjs from "dayjs";

const ProfileRow = ({ title, value }) => {
  return (
    <Row className="mb-3">
      <Col xs={12} md={3} xl={2}>
        <div className="d-flex gap-1 align-items-center text-xl text-gray-500">
          <div className="fw-semibold text-2xl">{title}</div>
          <div className="fw-semibold text-2xl">:</div>
        </div>
      </Col>
      <Col>
        <div className="text-2xl text-gray-500">
          {value || "-"}
        </div>
      </Col>
    </Row>
  );
};

const InfoView = ({ data, isLoading }) => {
  const [profileImage, setProfileImage] = useState(null);

  // Update profile image when data changes
  useEffect(() => {
    if (data?.profilePicture) {
      setProfileImage(data.profilePicture);
    }
  }, [data?.profilePicture]);

  // Show loading state
  if (isLoading || !data) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <div className="flex mt-2">
      <div className="flex-shrink-0">
        <Avatar
          size="lg"
          src={profileImage}
          alt={`${data?.firstName || ''} ${data?.lastName || ''}`.trim() || 'User'}
        />
      </div>
      <div className="flex-grow-1 w-full ms-3">
        <ProfileRow
          title="ชื่อ-นามสกุล"
          value={`${data?.firstName || ''} ${data?.lastName || ''}`.trim() || '-'}
        />
        <ProfileRow
          title="วันเกิด"
          value={data?.birthdate ? dayjs(data.birthdate).format("DD/MM/YYYY") : "-"}
        />
        <ProfileRow
          title="เบอร์โทรศัพท์"
          value={data?.phoneNo || "-"}
        />
      </div>
    </div>
  );
};

export default withTranslation()(InfoView);